<div class="modal-header">
  <h2 class="modal-title">{{ 'agents.workingHoursModal.title' | translate }}</h2>
  <button type="button" class="btn-close" (click)="cancel()">
    <i class="ri-close-line"></i>
  </button>
</div>

<div class="modal-body" [class.centered-content]="allowAllHours">
  <div class="mb-4">
    <div class="form-check form-switch">
      <input class="form-check-input" type="checkbox" id="allowAllHoursSwitch" [(ngModel)]="allowAllHours">
      <label class="form-check-label" for="allowAllHoursSwitch">
        {{ 'agents.workingHoursModal.allowAnyTime' | translate }}
      </label>
    </div>
    <small class="text-muted">{{ 'agents.workingHoursModal.allowAnyTimeHint' | translate }}</small>
  </div>

  @if (!allowAllHours) {
    <h5 class="mb-3">{{ 'agents.workingHoursModal.allowedHours' | translate }}</h5>
    <div class="day-selector mb-3">
      @for (day of daysOfWeek; track day) {
        <div class="day-pill"
          [class.active]="isDayActive(day.value)">
          <span>{{ (day.label | translate) | slice: 0 : 3 }}</span>
        </div>
      }
    </div>
    @for (day of workingHours; track day) {
      <div class="day-config">
        <div class="d-flex align-items-center justify-content-between mb-2">
          <div>
            <h6 class="mb-0">{{ getDayLabel(day.dayWeek) }}</h6>
          </div>
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" [id]="'day-' + day.dayWeek" [(ngModel)]="day.active">
          </div>
        </div>
        @if (day.active) {
          <div>
            @for (hourRange of day.hours; track hourRange; let i = $index) {
              <div class="hour-range-row">
                <div class="d-flex align-items-center">
                  <div class="position-relative">
                    <input type="time" class="form-control" [(ngModel)]="hourRange.start">
                    <i class="ri-time-line time-icon"></i>
                  </div>
                  <span>—</span>
                  <div class="position-relative">
                    <input type="time" class="form-control" [(ngModel)]="hourRange.end">
                    <i class="ri-time-line time-icon"></i>
                  </div>
                  <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeHourRange(day, i)" [disabled]="day.hours.length === 1">
                    <i class="ri-delete-bin-line"></i>
                  </button>
                </div>
                @if (!isValidHourRange(hourRange)) {
                  <small class="text-danger">
                    {{ 'agents.workingHoursModal.invalidHourRange' | translate }}
                  </small>
                }
              </div>
            }
            <button type="button" class="btn-add-interval" (click)="addHourRange(day)">
              <i class="ri-add-line"></i> {{ 'agents.workingHoursModal.addInterval' | translate }}
            </button>
          </div>
        }
      </div>
    }
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="cancel()">{{ 'agents.workingHoursModal.cancel' | translate }}</button>
  <button type="button" class="btn btn-primary" (click)="apply()">{{ 'agents.workingHoursModal.save' | translate }}</button>
</div>
